import { useEffect, useState } from 'react';

// The current time, refreshed on an interval, so things that depend on it (the
// current round, "starts soon") change while the page stays open.
export function useNow(intervalMs = 30_000): Date {
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        const refresh = () => setNow(new Date());
        const id = setInterval(refresh, intervalMs);
        document.addEventListener('visibilitychange', refresh);
        window.addEventListener('focus', refresh);
        return () => {
            clearInterval(id);
            document.removeEventListener('visibilitychange', refresh);
            window.removeEventListener('focus', refresh);
        };
    }, [intervalMs]);

    return now;
}
